// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ts-serving-timing-badge {
  position: absolute;
  z-index: 1;
  top: auto;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  box-sizing: border-box;
  max-width: calc(100% - 8px);
  min-height: 18px;
  padding: 2px 5px;
  border: 1px solid var(--serving-timing-border);
  border-radius: 999px;
  background: var(--serving-timing-bg);
  color: var(--serving-timing-fg);
  font-family: inherit;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  /* Hover exposes timing details; ordinary clicks still bubble to table selection. */
  pointer-events: auto;
  user-select: none;
}

.ts-serving-timing-badge__context {
  font-size: 7px;
  font-weight: 800;
  text-transform: uppercase;
}

.ts-serving-timing-badge--green {
  --serving-timing-bg: #e4f3e9;
  --serving-timing-border: #bad9c4;
  --serving-timing-fg: #245c38;
}

.ts-serving-timing-badge--orange {
  --serving-timing-bg: #fff0d7;
  --serving-timing-border: #e9c78e;
  --serving-timing-fg: #70450b;
}

.ts-serving-timing-badge--red {
  /* Explicit hour/minute labels need more room than the old min:sec clock. */
  max-width: calc(100% + 12px);
  padding: 2px 4px;
  font-size: 9px;
  --serving-timing-bg: #b91c1c;
  --serving-timing-border: #991b1b;
  --serving-timing-fg: #ffffff;
}

.ts-serving-timing-badge--neutral {
  --serving-timing-bg: #edf0f1;
  --serving-timing-border: #d0d7d9;
  --serving-timing-fg: #45545a;
}

.ts-serving-timing-badge__clock {
  flex: 0 0 10px;
  width: 10px;
  height: 10px;
  stroke: currentColor;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.ts-serving-timing-badge__text {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ts-serving-timing-badge__label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.ts-serving-timing-badge__display {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
}

.dark .ts-serving-timing-badge--green {
  --serving-timing-bg: #173d2a;
  --serving-timing-border: #2f6846;
  --serving-timing-fg: #a9e0bb;
}

.dark .ts-serving-timing-badge--orange {
  --serving-timing-bg: #493519;
  --serving-timing-border: #795727;
  --serving-timing-fg: #f3d08f;
}

.dark .ts-serving-timing-badge--red {
  --serving-timing-bg: #b91c1c;
  --serving-timing-border: #ef4444;
  --serving-timing-fg: #ffffff;
}

.dark .ts-serving-timing-badge--neutral {
  --serving-timing-bg: #303b40;
  --serving-timing-border: #4b5a60;
  --serving-timing-fg: #c1cdd1;
}

@media (max-width: 480px) {
  .ts-serving-timing-badge {
    bottom: -9px;
    min-height: 17px;
    padding: 2px 4px;
    font-size: 9px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/ServingTimingBadge/ServingTimingBadge.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,oBAAoB;EACpB,oCAAoC;EACpC,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mFAAmF;EACnF,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,2EAA2E;EAC3E,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":[".ts-serving-timing-badge {\n  position: absolute;\n  z-index: 1;\n  top: auto;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  box-sizing: border-box;\n  max-width: calc(100% - 8px);\n  min-height: 18px;\n  padding: 2px 5px;\n  border: 1px solid var(--serving-timing-border);\n  border-radius: 999px;\n  background: var(--serving-timing-bg);\n  color: var(--serving-timing-fg);\n  font-family: inherit;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  white-space: nowrap;\n  /* Hover exposes timing details; ordinary clicks still bubble to table selection. */\n  pointer-events: auto;\n  user-select: none;\n}\n\n.ts-serving-timing-badge__context {\n  font-size: 7px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.ts-serving-timing-badge--green {\n  --serving-timing-bg: #e4f3e9;\n  --serving-timing-border: #bad9c4;\n  --serving-timing-fg: #245c38;\n}\n\n.ts-serving-timing-badge--orange {\n  --serving-timing-bg: #fff0d7;\n  --serving-timing-border: #e9c78e;\n  --serving-timing-fg: #70450b;\n}\n\n.ts-serving-timing-badge--red {\n  /* Explicit hour/minute labels need more room than the old min:sec clock. */\n  max-width: calc(100% + 12px);\n  padding: 2px 4px;\n  font-size: 9px;\n  --serving-timing-bg: #b91c1c;\n  --serving-timing-border: #991b1b;\n  --serving-timing-fg: #ffffff;\n}\n\n.ts-serving-timing-badge--neutral {\n  --serving-timing-bg: #edf0f1;\n  --serving-timing-border: #d0d7d9;\n  --serving-timing-fg: #45545a;\n}\n\n.ts-serving-timing-badge__clock {\n  flex: 0 0 10px;\n  width: 10px;\n  height: 10px;\n  stroke: currentColor;\n  stroke-width: 1.5;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.ts-serving-timing-badge__text {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 3px;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ts-serving-timing-badge__label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ts-serving-timing-badge__display {\n  flex: 0 0 auto;\n  font-variant-numeric: tabular-nums;\n}\n\n.dark .ts-serving-timing-badge--green {\n  --serving-timing-bg: #173d2a;\n  --serving-timing-border: #2f6846;\n  --serving-timing-fg: #a9e0bb;\n}\n\n.dark .ts-serving-timing-badge--orange {\n  --serving-timing-bg: #493519;\n  --serving-timing-border: #795727;\n  --serving-timing-fg: #f3d08f;\n}\n\n.dark .ts-serving-timing-badge--red {\n  --serving-timing-bg: #b91c1c;\n  --serving-timing-border: #ef4444;\n  --serving-timing-fg: #ffffff;\n}\n\n.dark .ts-serving-timing-badge--neutral {\n  --serving-timing-bg: #303b40;\n  --serving-timing-border: #4b5a60;\n  --serving-timing-fg: #c1cdd1;\n}\n\n@media (max-width: 480px) {\n  .ts-serving-timing-badge {\n    bottom: -9px;\n    min-height: 17px;\n    padding: 2px 4px;\n    font-size: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
